var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 72,
    viewBox: "0 0 116 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#ff5f00",
    stroke: "none",
    d: "M 42.5 7.699997 L 74 7.699997 L 74 64.300003 L 42.5 64.300003 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#eb001b",
    stroke: "none",
    d: "M 44.5 36 C 44.5 25 49.599998 14.5 58.200001 7.699997 C 42.599998 -4.599998 20 -1.900002 7.7 13.799999 C -4.6 29.400002 -1.9 52 13.8 64.300003 C 26.9 74.599998 45.200001 74.599998 58.299999 64.300003 C 49.599998 57.5 44.5 47 44.5 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#f79e1b",
    stroke: "none",
    d: "M 116.5 36 C 116.5 55.900002 100.400002 72 80.5 72 C 72.400002 72 64.599998 69.300003 58.299999 64.300003 C 73.900002 52 76.599998 29.400002 64.300003 13.700001 C 62.5 11.5 60.5 9.400002 58.299999 7.699997 C 73.900002 -4.599998 96.599998 -1.900002 108.800003 13.799999 C 113.800003 20.099998 116.5 27.900002 116.5 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#f79e1b",
    stroke: "none",
    d: "M 113.099998 58.299999 L 113.099998 57.099998 L 113.599998 57.099998 L 113.599998 56.900002 L 112.400002 56.900002 L 112.400002 57.099998 L 112.900002 57.099998 L 112.900002 58.299999 L 113.099998 58.299999 Z M 115.400002 58.299999 L 115.400002 56.900002 L 115 56.900002 L 114.599998 57.900002 L 114.199997 56.900002 L 113.800003 56.900002 L 113.800003 58.299999 L 114.099998 58.299999 L 114.099998 57.200001 L 114.5 58.099998 L 114.800003 58.099998 L 115.199997 57.200001 L 115.199997 58.299999 L 115.400002 58.299999 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.5e6c17189c779ab7a8bd110b8a269f4b.svg";
export { ForwardRef as ReactComponent };